import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionEyebrow } from "./SectionEyebrow";

export const CTASection = ({ index = "06", label = "Contacto", title, text, buttonLabel, to = "/contacto" }) => (
  <section data-testid="cta-section" className="border-t border-onix-line">
    <div className="onix-shell py-24 md:py-36">
      <div className="grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-8">
          <Reveal>
            <SectionEyebrow index={index} label={label} />
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-serif text-onix-white mb-6 max-w-2xl">{title}</h2>
            <p className="text-base leading-relaxed text-onix-silver max-w-xl mb-10">{text}</p>
            <Link data-testid="cta-section-button" to={to} className="btn-onix-primary">
              {buttonLabel}
              <ArrowRight size={14} aria-hidden="true" />
            </Link>
          </Reveal>
        </div>
        <div className="hidden lg:flex lg:col-span-4 items-end justify-end">
          <span className="tech-label">ONIX · INTELLIGENCE & CYBERSECURITY SYSTEMS</span>
        </div>
      </div>
    </div>
  </section>
);
